module.exports = __webpack_public_path__ + "media/images/flags/gg-6b23b5b1092e831766f94b8df740deff.svg";